import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the WidgetResultByDivision state domain
 */

const selectWidgetResultByDivisionDomain = (state) =>
  state.get("widgetResultByDivision", initialState)

/**
 * Other specific selectors
 */
export const makeSelectIsLoadingDivisions = () =>
  createSelector(selectWidgetResultByDivisionDomain, (state) =>
    state.get("isLoadingDivisions")
  )

export const makeSelectDivisionsDrillDown = () =>
  createSelector(selectWidgetResultByDivisionDomain, (state) =>
    state.get("divisionsDrillDown")
  )

export const makeSelectDimensions = () =>
  createSelector(selectWidgetResultByDivisionDomain, (state) =>
    state.get("dimensions")
  )

export const makeSelectMetric = () =>
  createSelector(selectWidgetResultByDivisionDomain, (state) =>
    state.get("metric")
  )

/**
 * Default selector used by WidgetResultByDivision
 */

const makeSelectWidgetResultByDivision = () =>
  createSelector(selectWidgetResultByDivisionDomain, (substate) =>
    substate.toJS()
  )

export default makeSelectWidgetResultByDivision
export { selectWidgetResultByDivisionDomain }
